import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=89d4e3e0&"
import script from "./VideoModal.vue?vue&type=script&lang=js&"
export * from "./VideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89d4e3e0')) {
      api.createRecord('89d4e3e0', component.options)
    } else {
      api.reload('89d4e3e0', component.options)
    }
    module.hot.accept("./VideoModal.vue?vue&type=template&id=89d4e3e0&", function () {
      api.rerender('89d4e3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/VideoModal.vue"
export default component.exports